import { Typography, useTheme } from "@mui/material"
import { LibraryIcon } from "@/components/icons"

const EmptyData = ({ message, height, icon, color }: { message?: string, height?: number, icon?: React.ElementType, color?: string }) => {

    const theme = useTheme()

    const Icon = icon ?? LibraryIcon

    return (
        <Typography
            className={'flexCenter flexColumn'}
            sx={{
                width: '100%',
                minHeight: `${height ?? 200}px`,
                flex: 1,
                '& svg': {
                    color: color ?? theme.palette.text.disabled,
                    height: '38px',
                    width: '38px'
                }

            }}>
            <Icon />
            {message ?? 'Data not available'}
        </Typography>
    )
}

export default EmptyData